const mutations = {
  setTotalDraftsCount(state, payload) {
    state.totalDraftsCount = payload
  }
}

export default mutations